import { alpha, IconButton } from '@mui/material';

interface WisdomChatListDrawerToggleButtonProps {
  icon: React.ReactNode;
  onClick?: () => void;
}

export const WisdomChatListDrawerToggleButton = ({
  icon,
  onClick,
}: WisdomChatListDrawerToggleButtonProps) => {
  return (
    <IconButton
      sx={{
        backgroundColor: 'primary.main',
        color: 'white',
        borderRadius: 1,
        height: 32,
        width: 16,
        padding: 0,
        '&: hover': {
          backgroundColor: (theme) => alpha(theme.palette.primary.main, 0.8),
        },
      }}
      size="small"
      onClick={onClick}
    >
      {icon}
    </IconButton>
  );
};
